import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import AccountServiceModel from '@/models/AccountServiceModel';

@model.cacheDuration()
@model.urnResource('invoice_type')
@doc.path('/invoice_types/{?id}')
export default class InvoiceTypeModel extends AccountServiceModel {
	@doc.string declare label: string;
}